import {ArenaGameFilterEditor} from "./arena-game-filter-editor";
import {IArenaGameFiltersCategoryEditorViewModel} from "./arena-game-filters-category-editor-view-model.interface";
import {IArenaGameFiltersCategory} from "./arena-game-filters-category.interface";

export class ArenaGameFiltersCategoryEditor implements IArenaGameFiltersCategoryEditorViewModel {
    constructor(private readonly arenaGameFilterCategory: IArenaGameFiltersCategory) {
        this._filters = arenaGameFilterCategory.filters.map(f => new ArenaGameFilterEditor(f));
    }

    private _filters: ArenaGameFilterEditor[];
    get visibleFilters(): ArenaGameFilterEditor[] {
        return this._filters.filter(f => f.shouldBeDisplayed);
    }

    get title(): string {
        return this.arenaGameFilterCategory.title;
    }

    getAppliedFiltersIds(): string[] {
        return this._filters.filter(f => f.on).map(f => f.id);
    }
}